import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { useEffect, useState } from "react";
import { Typography, Grid } from "@mui/material";
import MCheck from "../../components/pos/MCheck";
import PText from "../../components/pos/PText";
import PCheck from "../../components/pos/PCheck";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const desktopTheme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      input: {
        padding: 10,
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
  },
});

export default function MServiceDetails(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;
  const [enableOKButton, setEnableOKButton] = useState(false);

  const [itemName, setItemName] = useState("");
  const [itemNameError, setItemNameError] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [serialNoError, setSerialNoError] = useState("");
  const [itemTypes, setItemTypes] = useState([]);
  const [complaints, setComplaints] = useState([]);

  const [itemNotes, setItemNotes] = useState("");
  const [complaintNotes, setComplaintNotes] = useState("");
  const [complaintNotesError, setComplaintNotesError] = useState("");
  const [itemNotesError, setItemNotesError] = useState("");
  const [liveValidation, setLiveValidation] = useState(false);

  const [label1, setLabel1] = useState("Item Name");
  const [label2, setLabel2] = useState("Serial No / Model");
  const [label3, setLabel3] = useState("Item Details");
  const [label4, setLabel4] = useState("Item Notes");
  const [label5, setLabel5] = useState("Complaints");
  const [label6, setLabel6] = useState("Complaint Notes");

  useEffect(() => {}, [props.productBean, props.pricingBean]);

  useEffect(() => {
    setEnableOKButton(itemName != "");
    if (liveValidation && itemName === "") {
      setItemNameError(translate("Item Name is Required"));
    } else {
      setItemNameError("");
    }
  }, [itemName]);

  useEffect(() => {
    console.log("JJ1 useEffect");

    if (props.serviceDataMode === "create") {
      if (props.productBean) {
        if (props.productBean.productInfoField1) {
          //setItemTypes(JSON.parse(props.productBean.productInfoField1));
          let arr = [];
          for (let d of JSON.parse(props.productBean.productInfoField1)) {
            arr.push({ value: d, selected: false });
          }
          setItemTypes(arr);
        }
        if (props.productBean.productInfoField2) {
          let arr = [];
          for (let d of JSON.parse(props.productBean.productInfoField2)) {
            arr.push({ value: d, selected: false });
          }
          setComplaints(arr);
        }
        if (props.productBean.productInfoField3) {
          let o = JSON.parse(props.productBean.productInfoField3);
          setLabel1(o.label1);
          setLabel2(o.label2);
          setLabel3(o.label3);
          setLabel4(o.label4);
          setLabel5(o.label5);
          setLabel6(o.label6);
        }
      }
    } else if (props.serviceDataMode === "update") {
      if (props.currentRow) {
        if (props.currentRow[9].info.productBean.productInfoField1) {
          setItemTypes(props.currentRow[9].info.serviceMeta.itemTypes);
        }
        if (props.currentRow[9].info.productBean.productInfoField2) {
          setComplaints(props.currentRow[9].info.serviceMeta.complaints);
        }
        setItemName(props.currentRow[9].info.serviceMeta.itemName);
        setSerialNo(props.currentRow[9].info.serviceMeta.serialNo);
        setItemNotes(props.currentRow[9].info.serviceMeta.itemNotes);
        setComplaintNotes(props.currentRow[9].info.serviceMeta.complaintNotes);
        if (props.productBean.productInfoField3) {
          let o = JSON.parse(props.productBean.productInfoField3);
          setLabel1(o.label1);
          setLabel2(o.label2);
          setLabel3(o.label3);
          setLabel4(o.label4);
          setLabel5(o.label5);
        }
      }
    }
  }, [props.serviceDataMode]);

  function onSave() {
    if (validate()) {
      let payload = createPayload();
      props.updateServiceDetails(payload, props.serviceDataMode);
      props.setCurrentScreen("sale");
    }
    //props.addService({});
  }

  function createPayload() {
    let object = {
      itemName: itemName,
      serialNo: serialNo,
      itemTypes: itemTypes,
      itemNotes: itemNotes,
      complaints: complaints,
      complaintNotes: complaintNotes,
    };
    return object;
  }

  function validate() {
    if (itemName == "") {
      setItemNameError("Item Name Required");
      setLiveValidation(true);
      return false;
    }
    return true;
  }

  function onItemDetailsChange(index, value) {
    let arr = [...itemTypes];
    arr[index].selected = value;
    setItemTypes(arr);
  }
  function onComplaintsDetailsChange(index, value) {
    let arr = [...complaints];
    complaints[index].selected = value;
    setComplaints(arr);
  }
  let mobileContent = (
    <div>
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "2px" }}>
          <MText
            label={translate(label1)}
            value={itemName}
            error={itemNameError}
            onChange={(e) => {
              setItemName(e.target.value);
            }}
          ></MText>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "6px" }}>
          <MText
            label={translate(label2)}
            value={serialNo}
            error={serialNoError}
            onChange={(e) => {
              setSerialNo(e.target.value);
            }}
          ></MText>
        </Grid>
        {itemTypes.length > 0 && (
          <Grid item xs={12} style={{ marginTop: "6px" }}>
            <Typography variant="body1">{label3}</Typography>
          </Grid>
        )}
        {itemTypes.map((v, index) => (
          <Grid item xs={12}>
            <MCheck
              key={index}
              onChange={(checked) => onItemDetailsChange(index, checked)}
              checked={v.selected}
              label={v.value}
            ></MCheck>
          </Grid>
        ))}

        <Grid item xs={12} style={{ marginTop: "6px" }}>
          <MText
            label={translate(label4)}
            value={itemNotes}
            error={itemNotesError}
            onChange={(e) => {
              setItemNotes(e.target.value);
            }}
          ></MText>
        </Grid>
        {complaints.length > 0 && (
          <Grid item xs={12} style={{ marginTop: "6px" }}>
            <Typography variant="body1">{label5}</Typography>
          </Grid>
        )}
        {complaints.map((v, index) => (
          <Grid item xs={12}>
            <MCheck
              key={index}
              onChange={(checked) => onComplaintsDetailsChange(index, checked)}
              checked={v.selected}
              label={v.value}
            ></MCheck>
          </Grid>
        ))}
        <Grid item xs={12} style={{ marginTop: "6px" }}>
          <MText
            label={translate(label6)}
            value={complaintNotes}
            error={complaintNotesError}
            onChange={(e) => {
              setComplaintNotes(e.target.value);
            }}
          ></MText>
        </Grid>
      </Grid>
    </div>
  );

  let desktopContent = (
    <ThemeProvider theme={desktopTheme}>
      <Grid container>
        <Grid item xs={2} style={{ marginTop: 8 }}>
          <Typography variant="body1">{label1}</Typography>
        </Grid>
        <Grid item xs={4}>
          <PText
            value={itemName}
            error={itemNameError}
            onChange={(e) => setItemName(e.target.value)}
          ></PText>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" style={{ marginTop: 8, paddingLeft: 10 }}>
            {label2}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <PText
            value={serialNo}
            error={serialNoError}
            onChange={(e) => setSerialNo(e.target.value)}
          ></PText>
        </Grid>
        {itemTypes.length > 0 && (
          <Grid item xs={2} style={{ marginTop: 16 }}>
            <Typography variant="body1">{label3}</Typography>
          </Grid>
        )}
        {itemTypes.length > 0 && (
          <Grid item xs={10} style={{ marginTop: 8 }}>
            {itemTypes.map((v, index) => (
              <PCheck
                key={index}
                onChange={(checked) => onItemDetailsChange(index, checked)}
                checked={v.selected}
                label={v.value}
              ></PCheck>
            ))}
          </Grid>
        )}

        <Grid item xs={2} style={{ marginTop: 16 }}>
          <Typography variant="body1">{label4}</Typography>
        </Grid>
        <Grid item xs={10} style={{ marginTop: 8 }}>
          <PText
            value={itemNotes}
            error={itemNotesError}
            onChange={(e) => setItemNotes(e.target.value)}
          ></PText>
        </Grid>

        {complaints.length > 0 && (
          <Grid item xs={2} style={{ marginTop: 16 }}>
            <Typography variant="body1">{label5}</Typography>
          </Grid>
        )}
        {complaints.length > 0 && (
          <Grid item xs={10} style={{ marginTop: 8 }}>
            {complaints.map((v, index) => (
              <PCheck
                key={index}
                onChange={(checked) =>
                  onComplaintsDetailsChange(index, checked)
                }
                checked={v.selected}
                label={v.value}
              ></PCheck>
            ))}
          </Grid>
        )}
        <Grid item xs={2} style={{ marginTop: 16 }}>
          <Typography variant="body1">{label6}</Typography>
        </Grid>
        <Grid item xs={10} style={{ marginTop: 8 }}>
          <PText
            value={complaintNotes}
            error={complaintNotesError}
            onChange={(e) => setComplaintNotes(e.target.value)}
          ></PText>
        </Grid>
      </Grid>
    </ThemeProvider>
  );

  return (
    <MScreen
      title={translate("Service")}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("sale")}
      rightAction={translate("OK")}
      onRightAction={() => {
        onSave();
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={
        props.context.appMode === "desktop-pos" ? true : enableOKButton
      }
      onLogOut={props.onLogOut}
      dialogMode={true}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      content={
        props.context.appMode === "desktop-pos" ? desktopContent : mobileContent
      }
    ></MScreen>
  );
}
